<template>
  <div class="industry-page">
    <!-- 如果没有指定行业类型，显示行业选择页 -->
    <div v-if="!industryType">
      <!-- ===== 行业选择首页 ===== -->
      <section class="gradient-blue text-white relative py-16">
        <div class="text-center">
          <h1 class="text-white/90">能源电力 制造业 数字化 行业解决方案</h1>
          <p class="mt-6 text-xl text-white/80 max-w-6xl mx-auto">
            面向央企、国企与行业龙头企业、集团类企业，构建数据与智能能力体系建设，提升数字人才数字工程应用能力。深耕五大重点行业，为能源、电力、制造、银行、保险、及央企国企提供数字化转型、数据治理、审计风控全栈解决方案
          </p>
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
            <div class="flex flex-wrap gap-4 justify-center">
                <h2 class="tag">内部审计</h2>
                <h2 class="tag">数字化审计</h2>
                <h2 class="tag">内部审计系统</h2>
                <h2 class="tag">审计管理平台</h2>
                <h2 class="tag">风险管理</h2>
                <h2 class="tag">风险管控平台</h2>
                <h2 class="tag">风险预警系统</h2>
                <h2 class="tag">数据合规</h2>
                <h2 class="tag">数据治理</h2>
                <h2 class="tag">数据资产管理平台</h2>
                <h2 class="tag">数字化人才培养体系</h2>
                <h2 class="tag">认证培训（CDGA、CDGP、CDMP）</h2>
                <h2 class="tag">人社证书培训（AI应用工程师）</h2>
                
                <h2 class="tag">数据分析能力</h2>
                <h2 class="tag">AI 能力建设</h2>
                
                <h2 class="tag">数据合规治理体系</h2>
                <h2 class="tag">数据资产运营体系</h2>
                <h2 class="tag">数据治理能力成熟度</h2>
                <h2 class="tag">复合型数字人才</h2>
            </div>
        </div>

      </section>

      <section class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div v-for="industry in industries" :key="industry.key" 
                 @click="selectIndustry(industry.key)"
                 class="bg-white p-8 rounded-2xl border border-divider card-hover hover:border-[#1F3F8F] cursor-pointer">
              <span class="text-6xl block mb-4">{{ industry.icon }}</span>
              <h3 class="text-2xl font-bold text-[#0E1F52] mb-3">{{ industry.name }}</h3>
              <p class="text-[#5A5E66] mb-4">{{ industry.description }}</p>
              <span class="text-brand font-medium">了解详情 →</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 根据行业类型显示对应内容 -->
    <div v-else>
      <!-- ===== 行业页面顶部 ===== -->
      <section class="bg-white pt-16 pb-0">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 class="text-4xl md:text-5xl font-bold text-[#0E1F52] mb-4">{{ currentIndustry.title }}</h1>
          <p class="text-lg text-[#5A5E66] max-w-3xl mx-auto">{{ currentIndustry.subtitle }}</p>
          <div class="mt-6 text-sm text-[#5A5E66]">
            <a v-for="(tag, index) in currentIndustry.tags" :key="index" 
               href="#" class="text-brand hover:underline">{{ tag }}</a>
            <span v-if="index < currentIndustry.tags.length - 1"> · </span>
          </div>
        </div>
      </section>

      <!-- ===== 行业挑战 ===== -->
      <section class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl md:text-4xl font-bold text-center text-[#0E1F52] mb-16">{{ currentIndustry.challengeTitle }}</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div v-for="(challenge, index) in currentIndustry.challenges" :key="index"
                 class="bg-[#F6F8FC] p-6 rounded-xl border border-divider text-center card-hover">
              <span class="text-5xl block mb-4">{{ challenge.icon }}</span>
              <h3 class="text-xl font-bold text-[#0E1F52] mb-2">{{ challenge.title }}</h3>
              <p class="text-[#5A5E66]">{{ challenge.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 解决方案 ===== -->
      <section class="py-20 bg-[#F6F8FC]">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl md:text-4xl font-bold text-center text-[#0E1F52] mb-16">{{ currentIndustry.solutionTitle }}</h2>
          <div class="bg-porcelain p-8 md:p-12 rounded-2xl border border-divider">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
              <div v-for="(solution, index) in currentIndustry.solutions" :key="index"
                   class="bg-white p-6 rounded-xl shadow-sm">
                <span class="text-2xl block mb-2">{{ solution.icon }}</span>
                <h3 class="font-bold text-[#0E1F52]">{{ solution.title }}</h3>
                <p class="text-sm text-[#5A5E66] mt-2">{{ solution.description }}</p>
              </div>
            </div>
            <p class="mt-8 text-center text-[#5A5E66]">{{ currentIndustry.solutionFooter }}</p>
          </div>
        </div>
      </section>

      <!-- ===== 典型场景 ===== -->
      <section class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl md:text-4xl font-bold text-center text-[#0E1F52] mb-16">典型应用场景</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div v-for="(scenario, index) in currentIndustry.scenarios" :key="index"
                 class="bg-white p-6 rounded-xl border border-divider card-hover">
              <span class="text-5xl block mb-4">{{ scenario.icon }}</span>
              <h3 class="text-xl font-bold text-[#0E1F52] mb-2">{{ scenario.title }}</h3>
              <p class="text-[#5A5E66]">{{ scenario.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 成功案例 ===== -->
      <section class="py-20 bg-[#F6F8FC]">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl md:text-4xl font-bold text-center text-[#0E1F52] mb-16">成功案例</h2>
          <div class="grid md:grid-cols-3 gap-8">
            <div v-for="(caseItem, index) in currentIndustry.cases" :key="index"
                 class="bg-white p-6 rounded-xl border border-divider">
              <span class="text-3xl bg-porcelain w-14 h-14 rounded-full flex items-center justify-center mb-4">{{ caseItem.icon }}</span>
              <h3 class="text-xl font-bold text-[#0E1F52]">{{ caseItem.title }}</h3>
              <p class="text-[#5A5E66] mt-2">{{ caseItem.description }}</p>
              <a href="#" class="mt-4 inline-block text-brand hover:underline">查看详情 →</a>
            </div>
          </div>
        </div>
      </section>

      <!-- 11 底部转化模块 -->
      <section id="contact" class="section" style="margin-bottom: 50px;">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 预约咨询 </h2>  
        <!-- early-bird-container: 早鸟容器，包括左侧 early-bird-left、右侧 early-bird-right -->
        <div class="p-10 rounded-2xl border border-divider shadow-sm" style="padding-top: 4rem; padding-bottom: 4rem;">
            <!-- Section-Title -->
            <div class="early-bird-container">
                <!-- 左侧文案 -->
                <div class="early-bird-left">
                  <h2 class="early-bird-title">
                    {{ courseName }}
                  </h2>
                  <div class="early-bird-info">
                    <p>
                      <i class="fas fa-calendar-alt"></i>
                      <span>开课时间：{{ startDate }}</span>
                    </p>
                    <p>
                      <i class="fas fa-users"></i>
                      <span>名额限制：仅剩 <span class="highlight">{{ spotsLeft }}</span> 席 / 每班{{ classSize }}人</span>
                    </p>
                    <p>
                      <i class="fas fa-gift"></i>
                      <span>早鸟优惠截止 <span class="highlight">{{ earlyBirdDeadline }}</span></span>
                    </p>
                  </div>
                </div>

                <!-- 右侧双二维码 -->
                <div class="early-bird-right">
                  <div
                    v-for="(advisor, index) in advisors"
                    :key="index"
                    class="advisor-card"
                  >
                    <div class="advisor-qr">
                      <i class="fas fa-qrcode"></i>
                      <!-- 实际使用时可用 <img :src="advisor.qrCode" alt="顾问二维码"> 替换 -->
                    </div>
                    <div class="advisor-name">{{ advisor.name }}</div>
                    <div class="advisor-title">{{ advisor.title }}</div>
                    <div class="advisor-hint">{{ advisor.hint }}</div>
                  </div>
                </div>
            </div>
        </div>
      </section>


    </div>
  </div>
</template>

<script>
export default {
  name: 'Industry',
  name1:'EarlyBirdSection',
    props: {
    // 课程名称，支持自定义
    courseName: {
      type: String,
      default: '报名本期 数据管理分析与治理 实践培训课程'
    },
    startDate: {
      type: String,
      default: '2025年6月20日（北京）'
    },
    spotsLeft: {
      type: [String, Number],
      default: 10
    },
    classSize: {
      type: [String, Number],
      default: 35
    },
    earlyBirdDeadline: {
      type: String,
      default: '3月31日'
    },
    // 顾问信息数组
    advisors: {
      type: Array,
      default: () => [
        {
          name: '顾老师',
          title: '首席咨询顾问',
          hint: '扫码咨询 · 抢占名额',
          qrCode: '' // 预留图片路径
        },
        {
          name: '桑老师',
          title: '课程规划专家',
          hint: '扫码咨询 · 获取大纲',
          qrCode: ''
        }
      ]
    }
  },
  data() {
    return {
      // 行业列表
      industries: [
        { key: 'energy', name: '能源', icon: '⚡', description: '生产数据治理 · 碳审计 · 智能运维' },
        { key: 'manufacturing', name: '制造', icon: '🏭', description: '质量追溯 · 供应链 · 指标系统' },
        { key: 'stateowned', name: '央企国企', icon: '🏛️', description: '数字化审计 · 合规管理 · 集团管控' },
        { key: 'bank', name: '银行', icon: '🏦', description: '数据治理 · 智能审计 · 监管报送' },
        { key: 'insurance', name: '保险', icon: '🛡️', description: '偿二代 · 反欺诈 · 风险管理' }
      ],
      // 各行业详细内容
      industryData: {
        energy: {
          name: '能源',
          title: '能源行业数字化转型与数据治理解决方案',
          subtitle: '为能源企业提供生产数据治理、碳审计、智能运维全栈解决方案',
          tags: ['生产数据治理', '碳审计', '智能运维'],
          challengeTitle: '能源行业数字化转型四大挑战',
          challenges: [
            { icon: '⚡', title: '生产数据分散', description: '发电、输电、配电等环节数据分散，难以统一管理' },
            { icon: '🌱', title: '碳审计压力', description: '双碳目标下，碳排放数据监测与审计需求迫切' },
            { icon: '🔧', title: '设备运维复杂', description: '设备故障预测难，停机损失大' },
            { icon: '📊', title: '指标体系缺失', description: '缺乏统一的生产指标体系，管理决策缺乏数据支撑' }
          ],
          solutionTitle: '能源行业一体化解决方案架构',
          solutions: [
            { icon: '🌱', title: '碳审计系统', description: '碳排放监测与审计' },
            { icon: '🔧', title: '智能运维', description: 'AI预测设备故障' },
            { icon: '📊', title: '生产指标管理', description: '统一生产指标体系' },
            { icon: '🗄️', title: '数据治理', description: '生产数据标准与质量' }
          ],
          solutionFooter: '基于工业互联网平台，实现生产-运维-管理全流程数字化',
          scenarios: [
            { icon: '🌱', title: '碳排放审计', description: '自动采集碳排放数据，生成碳审计报告，满足监管要求' },
            { icon: '🔧', title: '设备故障预测', description: 'AI预测设备故障，提前安排维修，减少停机损失' },
            { icon: '📊', title: '生产指标管理', description: '统一生产指标口径，实时监控核心指标' },
            { icon: '⚡', title: '能源调度优化', description: '基于AI的智能调度，提升能源利用效率' }
          ],
          cases: [
            { icon: '⚡', title: '国家能源集团 · 数据治理', description: '建立全集团数据资产目录，通过DCMM四级认证' },
            { icon: '⚡', title: '某电力公司 · 碳审计系统', description: '自动化碳排放监测，满足双碳目标要求' },
            { icon: '⚡', title: '某能源企业 · 智能运维', description: 'AI预测设备故障，停机时间减少40%' }
          ]
        },
        manufacturing: {
          name: '制造',
          title: '制造业数字化转型与质量管理解决方案',
          subtitle: '为制造企业提供质量追溯、供应链管理、生产指标系统',
          tags: ['质量追溯', '供应链管理', '生产指标'],
          challengeTitle: '制造业数字化转型四大挑战',
          challenges: [
            { icon: '🔍', title: '质量追溯难', description: '产品质量问题难以追溯到源头，召回成本高' },
            { icon: '📦', title: '供应链不透明', description: '供应链信息不透明，库存积压与缺货并存' },
            { icon: '📊', title: '生产数据缺失', description: '缺乏统一的生产指标体系，生产效率难以量化' },
            { icon: '🔧', title: '设备管理粗放', description: '设备维护依赖经验，缺乏预测性维护' }
          ],
          solutionTitle: '制造业一体化解决方案架构',
          solutions: [
            { icon: '🔍', title: '质量追溯系统', description: '全流程质量追溯' },
            { icon: '📦', title: '供应链管理', description: '供应链可视化与优化' },
            { icon: '📊', title: '生产指标管理', description: '统一生产指标体系' },
            { icon: '🔧', title: '设备管理', description: 'AI预测性维护' }
          ],
          solutionFooter: '基于工业互联网平台，实现从供应链到生产的全流程数字化',
          scenarios: [
            { icon: '🔍', title: '质量全程追溯', description: '从原料到成品全程追溯，质量问题快速定位' },
            { icon: '📦', title: '供应链优化', description: '供应链可视化，库存周转率提升30%' },
            { icon: '📊', title: '生产指标监控', description: '实时监控生产效率、良品率等核心指标' },
            { icon: '🔧', title: '预测性维护', description: 'AI预测设备故障，维护成本降低25%' }
          ],
          cases: [
            { icon: '🏭', title: '一汽集团 · 质量追溯系统', description: '全流程质量追溯，召回响应时间缩短60%' },
            { icon: '🏭', title: '某制造企业 · 供应链管理', description: '供应链可视化，库存周转率提升30%' },
            { icon: '🏭', title: '某装备制造 · 设备管理', description: 'AI预测性维护，设备故障率降低40%' }
          ]
        },
        stateowned: {
          name: '央企国企',
          title: '央企国企数字化转型与集团管控解决方案',
          subtitle: '为央企国企提供数字化审计、合规管理、集团管控全栈解决方案',
          tags: ['数字化审计', '合规管理', '集团管控'],
          challengeTitle: '央企国企数字化转型四大挑战',
          challenges: [
            { icon: '🏛️', title: '集团管控难', description: '多级法人架构，数据分散，集团管控力度不足' },
            { icon: '📋', title: '审计覆盖面窄', description: '传统审计依赖人工，覆盖面窄，难以持续审计' },
            { icon: '⚖️', title: '合规风险高', description: '国资监管要求高，合规风险监测难度大' },
            { icon: '📊', title: '数据标准缺失', description: '缺乏统一数据标准，报表口径不一致' }
          ],
          solutionTitle: '央企国企一体化解决方案架构',
          solutions: [
            { icon: '🔍', title: '数字化审计', description: '非现场审计与持续审计' },
            { icon: '⚖️', title: '合规管理', description: '实时合规监测与预警' },
            { icon: '📊', title: '集团管控', description: '统一数据标准与指标' },
            { icon: '🗄️', title: '数据治理', description: '主数据与数据质量管理' }
          ],
          solutionFooter: '基于集团数据中台，实现集团管控与业务协同',
          scenarios: [
            { icon: '🔍', title: '集团审计', description: '覆盖全集团的非现场审计，审计覆盖率85%' },
            { icon: '⚖️', title: '合规监测', description: '实时监测合规风险，提前预警异常情况' },
            { icon: '📊', title: '集团管控', description: '统一数据标准，实现集团级管理驾驶舱' },
            { icon: '🗄️', title: '数据治理', description: '建立集团数据资产目录，通过DCMM认证' }
          ],
          cases: [
            { icon: '🏛️', title: '某央企集团 · 审计平台', description: '覆盖全集团200+子公司，审计覆盖率85%' },
            { icon: '🏛️', title: '某国企集团 · 数据治理', description: '建立集团数据标准体系，通过DCMM四级' },
            { icon: '🏛️', title: '某能源集团 · 合规管理', description: '实时合规监测，合规问题响应时间缩短70%' }
          ]
        },
                bank: {
          name: '银行',
          title: '银行业数字化转型与数据治理解决方案',
          subtitle: '融合监管要求与行业最佳实践，为银行构建智能审计、风险合规、监管报送一体化平台',
          tags: ['银行数据治理', '智能审计', '监管报送'],
          challengeTitle: '银行业数字化转型四大挑战',
          challenges: [
            { icon: '🏦', title: '数据孤岛', description: '核心系统、信贷、信用卡、理财等系统数据分散，难以形成统一数据视图' },
            { icon: '⚖️', title: '风险合规压力', description: '信用风险、操作风险、合规风险交织，监管处罚力度持续加大' },
            { icon: '📊', title: '监管报送复杂', description: 'EAST、1104、反洗钱等数十套报表，口径多变，手工处理效率低易出错' },
            { icon: '🔍', title: '审计效率低', description: '依赖人工抽样，覆盖面窄，难以实现持续审计与风险预警' }
          ],
          solutionTitle: '银行业一体化解决方案架构',
          solutions: [
            { icon: '📊', title: '监管报送层', description: 'EAST、1104、反洗钱、利率报备等' },
            { icon: '🔍', title: '智能审计层', description: '非现场审计、持续审计、模型库' },
            { icon: '⚠️', title: '风险管理层', description: '信用风险、操作风险、合规风险' },
            { icon: '🗄️', title: '数据治理层', description: '数据标准、数据质量、主数据、指标' }
          ],
          solutionFooter: '基于统一数据底座，支撑全行数字化应用，满足监管合规与内部管理要求',
          scenarios: [
            { icon: '💳', title: '信贷风险审计', description: '自动抓取信贷数据，通过300+模型识别贷前、贷中、贷后风险，生成疑点清单' },
            { icon: '🕵️', title: '反洗钱监测', description: '基于图计算识别团伙洗钱，可疑交易报告生成效率提升50%' },
            { icon: '📋', title: '监管报表自动化', description: '一站式取数、计算、校验、报送，EAST报送时间从2周缩短至2天' },
            { icon: '📈', title: '内部审计数字化', description: '非现场审计覆盖率达90%，持续监控关键业务风险' }
          ],
          cases: [
            { icon: '🏦', title: '某国有大行 · 全行审计平台', description: '覆盖38家分行，300+审计模型，非现场审计覆盖率从15%提升至85%' },
            { icon: '🏦', title: '某股份制银行 · 数据治理项目', description: '建立全行数据标准与指标体系，EAST报送准确率提升至99.5%' },
            { icon: '🏦', title: '某城商行 · 智能风控系统', description: '实时监测信贷风险，不良贷款率下降0.8个百分点' }
          ]
        },
        insurance: {
          name: '保险',
          title: '保险业数字化转型与风险管理解决方案',
          subtitle: '助力保险公司实现偿二代合规、反欺诈、智能理赔，提升风险管理能力',
          tags: ['偿二代', '反欺诈', '智能理赔'],
          challengeTitle: '保险业数字化转型四大挑战',
          challenges: [
            { icon: '📋', title: '偿二代报送复杂', description: '偿二代监管报表数量多、口径复杂，数据质量要求高' },
            { icon: '🕵️', title: '欺诈风险高', description: '保险欺诈案件频发，传统规则难以识别复杂团伙欺诈' },
            { icon: '⏱️', title: '理赔效率低', description: '理赔流程长、人工审核慢，客户体验差' },
            { icon: '📊', title: '数据分散', description: '承保、理赔、财务等系统数据孤岛严重，难以形成统一风险视图' }
          ],
          solutionTitle: '保险业一体化解决方案架构',
          solutions: [
            { icon: '📊', title: '偿二代报送', description: '自动化报表生成与校验' },
            { icon: '🛡️', title: '反欺诈系统', description: '图计算+AI识别欺诈团伙' },
            { icon: '⚡', title: '智能理赔', description: 'OCR+AI自动审核理赔' },
            { icon: '🗄️', title: '数据治理', description: '客户、保单、理赔数据统一' }
          ],
          solutionFooter: '基于数据中台，实现承保-理赔-财务全流程数字化',
          scenarios: [
            { icon: '🕵️', title: '反欺诈识别', description: '基于图计算识别欺诈团伙，准确率95%，挽回损失超2亿元' },
            { icon: '📋', title: '偿二代报送', description: '自动化生成偿二代报表，准确率99%，报送时间缩短70%' },
            { icon: '⚡', title: '智能理赔', description: 'OCR识别发票+AI审核，小额理赔自动化率80%' },
            { icon: '📊', title: '风险预警', description: '实时监测核心风险指标，提前预警异常情况' }
          ],
          cases: [
            { icon: '🛡️', title: '中国人寿 · 反欺诈系统', description: '识别欺诈团伙准确率95%，年挽回损失超2亿元' },
            { icon: '🛡️', title: '某财险公司 · 智能理赔', description: '小额理赔自动化率80%，理赔周期缩短60%' },
            { icon: '🛡️', title: '某寿险公司 · 偿二代报送', description: '偿二代报表自动化，准确率99%，工作量降低70%' }
          ]
        }
      }
    }
  },
  
  computed: {
    industryType() {
      return this.$route.params.industryType
    },
    currentIndustry() {
      return this.industryData[this.industryType] || {}
    }
  },
  methods: {
    selectIndustry(key) {
      this.$router.push(`/industry/${key}`)
    }
  }
}
</script>

<style scoped>

:root {
  --white: #ffffff;
  --brand: #1F3F8F;        /* 可选，其他变量也可在此定义 */
}

.bg-white {
  background-color: #ffffff;
}

.text-white {
  color: #ffffff;
}

/* 支持透明度写法（若项目无工具处理，手动定义） */
.text-white\/80 {
  color: rgba(255, 255, 255, 0.8);
}

.text-white\/90 {
  color: rgba(255, 255, 255, 0.9);
}

/* 模板中使用的 bg-[#F6F8FC] 也可补充（若未使用 Tailwind 任意值） */
.bg-\[\#F6F8FC\] {
  background-color: #F6F8FC;
}


.industry-page {
  background-color: var(--white);
}

.gradient-blue {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
}

h1 {
  font-size: 2.5rem;
  line-height: 1.2;
  font-weight: 700;
}

@media (min-width: 768px) {
  h1 {
    font-size: 3rem;
  }
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31, 63, 143, 0.15);
}

.bg-porcelain {
  background-color: #EAF0FB;
}

.bg-brand {
  background-color: #1F3F8F;
}

.text-brand {
  color: #1F3F8F;
}

.border-divider {
  border-color: #E6EAF2;
}


/* 早鸟报名区域样式 - 青花瓷色系优化版 */
.early-bird-section {
  background-color: #e9edf4; /* 深靛蓝背景 */
  padding: 60px 0;
  margin: 60px 0;
  color: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.early-bird-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
}

/* 左侧文案区域 */
.early-bird-left {
  flex: 1 1 450px;
}

.early-bird-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 24px;
  color: #0E1F52;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 16px;
}

.early-bird-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background-color: #1F3F8F; /* 主蓝 */
  border-radius: 2px;
}

.early-bird-info p {
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #0E1F52;
  font-weight: 400;
}

.early-bird-info i {
  width: 24px;
  color: #1F3F8F; /* 主蓝 */
  font-size: 20px;
}

.early-bird-info .highlight {
  font-weight: 700;
  color: #2A5CAA; /* 稍亮的蓝色，更醒目 */
  background: rgba(255, 255, 255, 0.15);
  padding: 2px 10px;
  border-radius: 30px;
  margin-left: 4px;
  display: inline-block;
}

/* 右侧二维码区域 */
.early-bird-right {
  flex: 1 1 400px;
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.advisor-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 28px 20px 20px;
  text-align: center;
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.25);
  flex: 0 1 200px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(31, 63, 143, 0.1);
}

.advisor-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 25px 40px rgba(0, 0, 0, 0.3);
}

.advisor-qr {
  width: 120px;
  height: 120px;
  background: #EAF0FB; /* 淡瓷蓝 */
  border-radius: 20px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #1F3F8F;
  transition: border-color 0.2s;
}

.advisor-card:hover .advisor-qr {
  border-color: #2A5CAA;
}

.advisor-qr i {
  font-size: 60px;
  color: #1F3F8F;
  opacity: 0.85;
}

.advisor-name {
  font-weight: 700;
  font-size: 20px;
  color: #0E1F52; /* 深靛蓝 */
  margin-bottom: 4px;
}

.advisor-title {
  font-size: 14px;
  color: #5f6a7d;
  margin-bottom: 16px;
  font-weight: 400;
}

.advisor-hint {
  font-size: 14px;
  font-weight: 600;
  color: #1F3F8F;
  border-top: 1px dashed #d0d9e8;
  padding-top: 14px;
  margin-top: 6px;
  letter-spacing: 0.3px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .early-bird-container {
    flex-direction: column;
    text-align: center;
  }

  .early-bird-title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .early-bird-info p {
    justify-content: center;
  }

  .early-bird-right {
    gap: 20px;
  }

  .advisor-card {
    flex: 0 1 180px;
  }
}


/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {   
  background: rgb(205, 120, 120);
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: #D4AF37;
  color: #1e3c3c;
}



/* 栅格系统 */
.grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
}


/* 标签组 */
.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 24px 0 28px;
}
.tag {
    background: #ffffff;
    color: black;
    padding: 14px 28px;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgba(26,115,232,0.15);
    /* margin-bottom: 10px;   */
    max-width: 0;
    max-width:fit-content;
}



@media (max-width: 480px) {
  .early-bird-title {
    font-size: 28px;
  }

  .early-bird-info p {
    font-size: 16px;
    flex-wrap: wrap;
  }
}
</style>
